import { Capacitor } from "@capacitor/core";
import { ScreenBrightness } from "@capacitor-community/screen-brightness";

import { isCapacitorPlatform } from "./helpers";

let previousBrightness: number | null = null;

/**
 * @desc Sets the screen to full brightness so a displayed barcode scans reliably.
 * Native (Capacitor) only; no-op on mobile web (no browser API can raise the backlight).
 * On iOS the value is system-level and persists, so the current value is snapshotted for restore.
 */
export async function increaseScreenBrightness(): Promise<void> {
	if (!isCapacitorPlatform()) {
		return;
	}
	try {
		const { brightness } = await ScreenBrightness.getBrightness();
		previousBrightness = brightness;
		await ScreenBrightness.setBrightness({ brightness: 1 });
	} catch (e) {
		console.error("increaseScreenBrightness error:", e);
	}
}

/**
 * @desc Restores the brightness changed by increaseScreenBrightness.
 * Android supports -1 (restore user-configured brightness); iOS is set back to the snapshot.
 */
export async function restoreScreenBrightness(): Promise<void> {
	if (!isCapacitorPlatform()) {
		return;
	}
	try {
		if (Capacitor.getPlatform() === "android") {
			await ScreenBrightness.setBrightness({ brightness: -1 });
		} else if (previousBrightness != null) {
			await ScreenBrightness.setBrightness({
				brightness: previousBrightness,
			});
		}
	} catch (e) {
		console.error("restoreScreenBrightness error:", e);
	} finally {
		previousBrightness = null;
	}
}
